module.exports = __webpack_public_path__ + "components/flag/static/square/ht-319c3372c13c8d1fc9ece7b93ef0e490.svg";